"use client";

import React from "react";

//Type
import { ButtonLinkTableProps } from "@/types";

//Styles
import * as S from "./styles";

const ButtonLinkTable: React.FC<ButtonLinkTableProps> = ({
  className,
  text,
  onClick,
}) => {
  return (
    <S.ButtonTable className={className} onClick={onClick}>
      {text}
    </S.ButtonTable>
  );
};

export default ButtonLinkTable;
